import { Analytics } from '@cobliteam/analytics';
import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import { Location } from '@cobliteam/common-types';
import { useGetTracking } from '@cobliteam/hooks/src/useEntity/useTracking';
import Button from '@cobliteam/ui/components/Button';
import Dialog from '@cobliteam/ui/components/Dialog';
import Icon from '@cobliteam/ui/icons';
import { TrackingMap } from '@cobliteam/ui-business/components';
import DataTableAction from '@cobliteam/ui-business/components/DataTable/components/DataTableAction';
import PathAddressDetails from '@cobliteam/ui-business/components/dialogs/DriverConfirmationDialog/components/PathAddressDetails';
import { endOfDay, startOfDay } from '@cobliteam/utils/date';
import queryString from 'query-string';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import PathDetailsDialogSummary from './components/PathDetailsDialogSummary';

interface PathDetailsDialogProps {
  path: Path;
}

const PathDetailsDialog = ({ path }: PathDetailsDialogProps) => {
  const { type, startTime, endTime, vehicle } = path;

  const [open, setOpen] = useState(false);
  const isTrip = type === 'trip';

  const title = isTrip ? 'em movimento' : 'parado';
  const pathWindow = isTrip ? { start: startTime, end: endTime } : { start: startTime };

  const { data: tracking, isLoading: isTrackingLoading } = useGetTracking(vehicle?.id || '', startOfDay(startTime).getTime(), endOfDay(endTime).getTime(), true, {
    enabled: open && !!vehicle?.id,
  });

  const handleClick = () => {
    Analytics.track('Path Association - Details - Click');
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <DataTableAction icon={<Icon name='eye' />} tooltip='Ver detalhes' onClick={handleClick} />
      </Dialog.Trigger>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Detalhes do trecho {title}</Dialog.Title>
          <Dialog.Description className='sr-only' />
          <Dialog.Close />
        </Dialog.Header>
        <Dialog.Body className='flex flex-col gap-4'>
          <PathDetailsDialogSummary path={path} />
          <TrackingMap tracking={tracking} pathWindow={pathWindow} loading={isTrackingLoading} />
          <PathAddressDetails path={path} />
        </Dialog.Body>
        <Dialog.Footer className='flex items-center justify-between gap-2'>
          <Link
            to={{
              pathname: Location.TRACKING,
              search: queryString.stringify({
                vehicle_id: vehicle?.id || '',
                date: startOfDay(startTime).getTime(),
              }),
            }}
            target='_blank'
          >
            <Button variant='ghost' startIcon={<Icon name='external-link' />}>
              Ver trajeto completo
            </Button>
          </Link>

          <Dialog.Close asChild>
            <Button variant='ghost'>Fechar</Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};

export default PathDetailsDialog;
